import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { Table } from 'primeng/table';

export interface FilterOption {
    label: string;
    value: any;
}

export interface FilterConfig {
    key: string;
    label: string;
    type: 'select' | 'selectButton' | 'checkbox' | 'input' | 'dropdown';
    field?: string; // Field name for table filtering (optional for custom filters)
    matchMode?: string; // PrimeNG filter match mode (equals, contains, etc.)
    options?: FilterOption[]; // For select/dropdown types
    defaultValue?: any;
    isCustomFilter?: boolean; // If true, this filter will not be applied to the table
    customFilterFunction?: (value: any, allFilters: FiltresAvances) => void; // Custom function to execute when filter changes
}

export interface FiltresAvances {
    [key: string]: any;
}

@Component({
    selector: 'app-filtres-avances',
    templateUrl: './filtres-avances.component.html'
})
export class FiltresAvancesComponent implements OnInit, OnChanges {

    @Input() filterConfigs: FilterConfig[] = [];
    @Input() table: Table;
    @Input() filtres: FiltresAvances = {};
    @Output() filtresChanges = new EventEmitter<FiltresAvances>();

    constructor() { }

    ngOnInit() {
        this.initializeFiltres();
        this.appliquerFiltres();
    }

    ngOnChanges(changes: any) {
        if (changes.filterConfigs && !changes.filterConfigs.firstChange) {
            this.initializeFiltres();
        }
        if (changes.filtres && !changes.filtres.firstChange) {
            this.appliquerFiltres();
        }
    }

    private initializeFiltres() {
        if (!this.filtres) {
            this.filtres = {};
        }
        
        // Initialize filters with default values from config
        this.filterConfigs.forEach(config => {
            if (this.filtres[config.key] === undefined) {
                this.filtres[config.key] = config.defaultValue !== undefined ? config.defaultValue : null;
            }
        });
    }

    appliquerFiltres() {
        // Apply table filters (non-custom filters)
        if (this.table) {
            this.filterConfigs
                .filter(config => !config.isCustomFilter && config.field)
                .forEach(config => {
                    const filterValue = this.filtres[config.key];
                    const matchMode = config.matchMode || 'equals';
                    
                    this.table.filter(filterValue, config.field!, matchMode);
                    
                    // Update the table's filter state for proper persistence
                    if (!this.table.filters[config.field!]) {
                        this.table.filters[config.field!] = [];
                    }
                    this.table.filters[config.field!] = [{
                        value: filterValue,
                        matchMode: matchMode
                    }];
                });
        }

        // Execute custom filter functions
        this.filterConfigs
            .filter(config => config.isCustomFilter && config.customFilterFunction)
            .forEach(config => {
                const filterValue = this.filtres[config.key];
                config.customFilterFunction!(filterValue, this.filtres);
            });

        this.filtresChanges.emit(this.filtres);
    }

    onFilterChange() {
        this.appliquerFiltres();
    }
}
